export const useOrderData = defineStore('orderQueue', () => {
  const orderId = ref<string>('')

  return {
    orderId
  }
},
{
  persist: true
})
